module.exports = __webpack_public_path__ + "static/media/15.3b10d710.jpg";